import { Integration } from "src/app/core/models/integrations";

export interface LogEntry {
  timestamp: string;
  status: string;
  message: string;
}

export interface TenantMapping {
  internalTenantId: string;
  internalTenantName: string;
  externalTenantId: string;
  externalTenantName: string;
  agreementId: string;
  agreementName: string;
}

export interface MappedCompany {
  internalId: string;
  internalName: string;
  externalId: string;
  externalName: string;
}

export const entraidLogs: LogEntry[] = [
  { timestamp: '2023-11-01 10:00:00', status: 'active', message: 'Sync completed successfully' },
  { timestamp: '2023-11-01 08:00:00', status: 'warning', message: 'Sync completed with warnings' },
];

export const stellarLogs: LogEntry[] = [
  { timestamp: '2023-10-31 10:00:00', status: 'warning', message: 'API rate limit warning' },
  { timestamp: '2023-10-30 14:15:00', status: 'error', message: 'Connection timeout' },
  { timestamp: '2023-10-29 09:30:00', status: 'active', message: 'Sync completed successfully' },
];


export const tenantMappings: TenantMapping[] = [
  { internalTenantId: '1', internalTenantName: 'Acme Corp', externalTenantId: 'stellar-tenant-1', externalTenantName: 'Acme Corp', agreementId: 'A001', agreementName: 'Basic Monthly Plan' },
  { internalTenantId: '2', internalTenantName: 'Globex', externalTenantId: 'stellar-tenant-2', externalTenantName: 'Globex', agreementId: 'A002', agreementName: 'Sophos Endpoint & XDR' },
  { internalTenantId: '3', internalTenantName: 'Initech', externalTenantId: 'stellar-tenant-3', externalTenantName: 'Initech', agreementId: 'A003', agreementName: 'Monitoring Services Plus' },
];

// Add ConnectWise mock data
export const connectWiseBoards = [
  { id: 'B001', name: 'Service Board' },
  { id: 'B002', name: 'Project Board' },
  { id: 'B003', name: 'Incident Response' },
  { id: 'B004', name: 'Maintenance Board' },
  { id: 'B005', name: 'Security Board' },
];

export const connectWisePriorities = [
  { id: 'P001', name: 'Critical', level: 1 },
  { id: 'P002', name: 'High', level: 2 },
  { id: 'P003', name: 'Medium', level: 3 },
  { id: 'P004', name: 'Low', level: 4 },
];

export const cyflareTicketPriorities = [
  { id: 'CP001', name: 'Critical' },
  { id: 'CP002', name: 'High' },
  { id: 'CP003', name: 'Medium' },
  { id: 'CP004', name: 'Low' },
];

export const connectWiseStatuses = [
  { id: 'S001', name: 'Critical Impact' },
  { id: 'S002', name: 'Significant Impact' },
  { id: 'S003', name: 'Moderate Impact' },
  { id: 'S004', name: 'Minimal Impact' },
];

export const cyflareTicketStatuses = [
  { id: 'CS001', name: 'In Progress' },
  { id: 'CS002', name: 'Closed' },
];

export const internalCompanies = [
  { id: '1', name: 'CyFlare (MSSP)' },
  { id: '2', name: 'ACME' },
  { id: '3', name: 'Amnet Technology Solutions' },
  { id: '4', name: 'Amnetsystems (Amnet Technology) (MSP - Channel)' },
  { id: '5', name: 'Amnetsystems (Amnet Technology) (MSP - Channel) / Aethon' },
  { id: '6', name: 'Amnetsystems (Amnet Technology) (MSP - Channel) / Akero Therapeutics' },
  { id: '7', name: 'Amnetsystems (Amnet Technology) (MSP - Channel) / Accent Real Estate' },
];

export const externalCompanies = [
  { id: '101', name: '4268 Seneca Street, LLC' },
  { id: '102', name: '4th Wave Technologies, LLC' },
  { id: '103', name: 'Accent Stripe' },
  { id: '104', name: 'ACE Specialties' },
  { id: '105', name: 'ACP Technologies - Customer' },
  { id: '106', name: 'ACP Technologies - Texas' },
  { id: '107', name: 'Advancenet Technologies, LLC' },
  { id: '108', name: 'Agent2000 Commercial/Personal Ins' },
  { id: '109', name: 'Agness Insurance Agency, Inc.' },
  { id: '110', name: 'Alamo Drafting & Design' },
];

export const connectWiseAgreements = [
  { id: 'A001', name: 'Basic Monthly Plan' },
  { id: 'A002', name: 'Sophos Endpoint & XDR' },
  { id: 'A003', name: 'Monitoring Services Plus' },
  { id: 'A004', name: 'Sophos' },
  { id: 'A005', name: 'Premium Support Plan' },
  { id: 'A006', name: 'Advanced Security Package' },
];

// Sample tenant mapping data
export const sampleTenantMappings: TenantMapping[] = [
  {
    internalTenantId: '1',
    internalTenantName: 'CyFlare (MSSP)',
    externalTenantId: '105',
    externalTenantName: 'ACP Technologies - Customer',
    agreementId: 'A001',
    agreementName: 'Basic Monthly Plan',
  },
  {
    internalTenantId: '2',
    internalTenantName: 'ACME',
    externalTenantId: '103',
    externalTenantName: 'Accent Stripe',
    agreementId: 'A002',
    agreementName: 'Sophos Endpoint & XDR',
  },
  {
    internalTenantId: '3',
    internalTenantName: 'Amnet Technology Solutions',
    externalTenantId: '107',
    externalTenantName: 'Advancenet Technologies, LLC',
    agreementId: 'A003',
    agreementName: 'Monitoring Services Plus',
  },
  {
    internalTenantId: '4',
    internalTenantName: 'Amnetsystems (Amnet Technology) (MSP - Channel)',
    externalTenantId: '108',
    externalTenantName: 'Agent2000 Commercial/Personal Ins',
    agreementId: 'A004',
    agreementName: 'Sophos',
  },
  {
    internalTenantId: '5',
    internalTenantName: 'Amnetsystems (Amnet Technology) (MSP - Channel) / Aethon',
    externalTenantId: '109',
    externalTenantName: 'Agness Insurance Agency, Inc.',
    agreementId: 'A005',
    agreementName: 'Premium Support Plan',
  },
  {
    internalTenantId: '6',
    internalTenantName: 'Amnetsystems (Amnet Technology) (MSP - Channel) / Akero Therapeutics',
    externalTenantId: '110',
    externalTenantName: 'Alamo Drafting & Design',
    agreementId: 'A006',
    agreementName: 'Advanced Security Package',
  },
  {
    internalTenantId: '7',
    internalTenantName: 'Amnetsystems (Amnet Technology) (MSP - Channel) / Accent Real Estate',
    externalTenantId: '101',
    externalTenantName: '4268 Seneca Street, LLC',
    agreementId: 'A001',
    agreementName: 'Basic Monthly Plan',
  },
  {
    internalTenantId: '8',
    internalTenantName: 'Western Digital',
    externalTenantId: '102',
    externalTenantName: '4th Wave Technologies, LLC',
    agreementId: 'A002',
    agreementName: 'Sophos Endpoint & XDR',
  },
  {
    internalTenantId: '9',
    internalTenantName: 'Kingston Technology',
    externalTenantId: '104',
    externalTenantName: 'ACE Specialties',
    agreementId: 'A003',
    agreementName: 'Monitoring Services Plus',
  },
  {
    internalTenantId: '10',
    internalTenantName: 'Seagate Solutions',
    externalTenantId: '106',
    externalTenantName: 'ACP Technologies - Texas',
    agreementId: 'A004',
    agreementName: 'Sophos',
  },
  {
    internalTenantId: '11',
    internalTenantName: 'Toshiba Electronics',
    externalTenantId: '105',
    externalTenantName: 'ACP Technologies - Customer',
    agreementId: 'A005',
    agreementName: 'Premium Support Plan',
  },
  {
    internalTenantId: '12',
    internalTenantName: 'Samsung Displays',
    externalTenantId: '103',
    externalTenantName: 'Accent Stripe',
    agreementId: 'A006',
    agreementName: 'Advanced Security Package',
  },
  {
    internalTenantId: '13',
    internalTenantName: 'LG Electronics',
    externalTenantId: '107',
    externalTenantName: 'Advancenet Technologies, LLC',
    agreementId: 'A001',
    agreementName: 'Basic Monthly Plan',
  },
  {
    internalTenantId: '14',
    internalTenantName: 'Phillips Lighting',
    externalTenantId: '108',
    externalTenantName: 'Agent2000 Commercial/Personal Ins',
    agreementId: 'A002',
    agreementName: 'Sophos Endpoint & XDR',
  },
  {
    internalTenantId: '15',
    internalTenantName: 'IBM Corporation',
    externalTenantId: '109',
    externalTenantName: 'Agness Insurance Agency, Inc.',
    agreementId: 'A003',
    agreementName: 'Monitoring Services Plus',
  },
  {
    internalTenantId: '16',
    internalTenantName: 'Oracle Systems',
    externalTenantId: '110',
    externalTenantName: 'Alamo Drafting & Design',
    agreementId: 'A004',
    agreementName: 'Sophos',
  },
  {
    internalTenantId: '17',
    internalTenantName: 'Microsoft Corporation',
    externalTenantId: '101',
    externalTenantName: '4268 Seneca Street, LLC',
    agreementId: 'A005',
    agreementName: 'Premium Support Plan',
  },
  {
    internalTenantId: '18',
    internalTenantName: 'Google Cloud',
    externalTenantId: '102',
    externalTenantName: '4th Wave Technologies, LLC',
    agreementId: 'A006',
    agreementName: 'Advanced Security Package',
  },
  {
    internalTenantId: '19',
    internalTenantName: 'Amazon Web Services',
    externalTenantId: '104',
    externalTenantName: 'ACE Specialties',
    agreementId: 'A001',
    agreementName: 'Basic Monthly Plan',
  },
  {
    internalTenantId: '20',
    internalTenantName: 'Alibaba Cloud',
    externalTenantId: '106',
    externalTenantName: 'ACP Technologies - Texas',
    agreementId: 'A002',
    agreementName: 'Sophos Endpoint & XDR',
  },
  {
    internalTenantId: '21',
    internalTenantName: 'Salesforce',
    externalTenantId: '105',
    externalTenantName: 'ACP Technologies - Customer',
    agreementId: 'A003',
    agreementName: 'Monitoring Services Plus',
  },
  {
    internalTenantId: '22',
    internalTenantName: 'Adobe Systems',
    externalTenantId: '103',
    externalTenantName: 'Accent Stripe',
    agreementId: 'A004',
    agreementName: 'Sophos',
  },
  {
    internalTenantId: '23',
    internalTenantName: 'Autodesk Inc',
    externalTenantId: '107',
    externalTenantName: 'Advancenet Technologies, LLC',
    agreementId: 'A005',
    agreementName: 'Premium Support Plan',
  },
  {
    internalTenantId: '24',
    internalTenantName: 'Intuit Software',
    externalTenantId: '108',
    externalTenantName: 'Agent2000 Commercial/Personal Ins',
    agreementId: 'A006',
    agreementName: 'Advanced Security Package',
  },
  {
    internalTenantId: '25',
    internalTenantName: 'Cisco Systems',
    externalTenantId: '109',
    externalTenantName: 'Agness Insurance Agency, Inc.',
    agreementId: 'A001',
    agreementName: 'Basic Monthly Plan',
  },
  {
    internalTenantId: '26',
    internalTenantName: 'Juniper Networks',
    externalTenantId: '110',
    externalTenantName: 'Alamo Drafting & Design',
    agreementId: 'A002',
    agreementName: 'Sophos Endpoint & XDR',
  },
  {
    internalTenantId: '27',
    internalTenantName: 'Fortinet Security',
    externalTenantId: '101',
    externalTenantName: '4268 Seneca Street, LLC',
    agreementId: 'A003',
    agreementName: 'Monitoring Services Plus',
  },
  {
    internalTenantId: '28',
    internalTenantName: 'Palo Alto Networks',
    externalTenantId: '102',
    externalTenantName: '4th Wave Technologies, LLC',
    agreementId: 'A004',
    agreementName: 'Sophos',
  },
  {
    internalTenantId: '29',
    internalTenantName: 'VMware Inc',
    externalTenantId: '104',
    externalTenantName: 'ACE Specialties',
    agreementId: 'A005',
    agreementName: 'Premium Support Plan',
  },
  {
    internalTenantId: '30',
    internalTenantName: 'Dell Technologies',
    externalTenantId: '106',
    externalTenantName: 'ACP Technologies - Texas',
    agreementId: 'A006',
    agreementName: 'Advanced Security Package',
  },
];
